import { defaultActionCreator } from "../../actionCreator";

export const SET_STATE = "dashboard/SET_STATE";
export const setState = defaultActionCreator(SET_STATE, "payload");

export const GET_SUMMARY = "GET_SUMMARY";
export const getSummary = defaultActionCreator(GET_SUMMARY);
